import { render, staticRenderFns } from "./ScanCourier.vue?vue&type=template&id=26d00426&scoped=true"
import script from "./ScanCourier.vue?vue&type=script&lang=js"
export * from "./ScanCourier.vue?vue&type=script&lang=js"
import style0 from "./ScanCourier.vue?vue&type=style&index=0&id=26d00426&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d00426",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26d00426')) {
      api.createRecord('26d00426', component.options)
    } else {
      api.reload('26d00426', component.options)
    }
    module.hot.accept("./ScanCourier.vue?vue&type=template&id=26d00426&scoped=true", function () {
      api.rerender('26d00426', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/Operation/ScanCourier.vue"
export default component.exports